/**
 * Remove prefixos de referência do documento para exibição limpa.
 * @param {string} value
 * @returns {string}
 */
export function stripReferenciaDocumento(value) {
  if (value == null || typeof value !== 'string') return value;
  let s = value.trim();

  s = s.replace(/^\s*P[aá]g\.?\s*\d+\s+de\s+\d+\s*-\s*/i, '').trim();

  s = s
    .replace(/\s*PREGÃO\s*ELETRÔNICO\s*Nº\s*E\s*D\s*I\s*T\s*A\s*L,?\s*página\s*\d+\s*-\s*/gi, '')
    .replace(/\s*E\s*D\s*I\s*T\s*A\s*L,?\s*Cláusula\s+[\d.]+,?\s*página\s*\d+\s*-\s*/gi, '')
    .replace(/\s*EDITAL,?\s*Cláusula\s+[\d.]+,?\s*página\s*\d+\s*-\s*/gi, '')
    .replace(/\s*E\s*D\s*I\s*T\s*A\s*L,?\s*página\s*\d+\s*-\s*/gi, '')
    .replace(/\s*EDITAL,?\s*página\s*\d+\s*-\s*/gi, '')
    .trim();

  const editalTrMinuta =
    /^\s*(?:Edital|TR|Minuta)\s+[\d.]+\s*,\s*(?:página|p\.)\s*\d+\s*-\s*(?:[A-Za-z]\s*)?/i;
  let prevEt;
  do {
    prevEt = s;
    s = s.replace(editalTrMinuta, '').trim();
  } while (s !== prevEt);

  const anexoSubsecao =
    /^\s*ANEXO\s+[\s\S]+?,\s*[\d.]+\s*,\s*(?:página|p\.)\s*\d+\s*-\s*/i;
  do {
    prevEt = s;
    s = s.replace(anexoSubsecao, '').trim();
  } while (s !== prevEt);

  s = s
    .replace(/^\s*ANEXO\s+[IVX\d]+[^\w]*–?\s*[^,]*,\s*Tabela\s+\d+,?\s*página\s+\d+\s*-\s*/gi, '')
    .replace(/^\s*ANEXO\s+[IVX\d]+[^\w]*,\s*Tabela\s+\d+,?\s*página\s+\d+\s*-\s*/gi, '')
    .replace(/^\s*ANEXO\s+[IVX\d]+[^\w]*–?\s*[^,]*,\s*página\s+\d+\s*-\s*/gi, '')
    .replace(/^\s*ANEXO\s+[IVX\d]+[^\w]*,\s*página\s+\d+\s*-\s*/gi, '')
    .trim();

  s = s.replace(/^\s*Tabela\s+\d+,?\s*página\s+\d+\s*-\s*/gi, '').trim();

  const clausulaComP = /^\s*CL[ÁA]USULA\s+[\s\S]+?,\s*p\.?\s*\d+\s*-\s*/i;
  do {
    prevEt = s;
    s = s.replace(clausulaComP, '').trim();
  } while (s !== prevEt);

  const itemNumeroP = /^\s*item\s*\d+\s*,\s*p\.?\s*\d+\s*-\s*/i;
  do {
    prevEt = s;
    s = s.replace(itemNumeroP, '').trim();
  } while (s !== prevEt);

  const refBlock =
    /^\s*(?:(?:Page\s*\d+|Página\s*\d+|p\.?\s*\d+|Primeira\s+p[aá]gina)(?:,\s*[^-]+)?|Cláusula\s*[\d.]+,?\s*(?:página\s*\d+|p\.?\s*\d+)?\s*|Seção\s*[\d.]+,?\s*(?:página\s*\d+|p\.?\s*\d+)?\s*|Preâmbulo|Item\s*\d+)\s*-\s*/i;
  let prev;
  do {
    prev = s;
    s = s.replace(refBlock, '').trim();
  } while (s !== prev);

  s = s.replace(/^\s*;\s*/g, '').trim();
  return s || value;
}
